import { Fragment, useEffect, useState } from "react";

//component
import CheckDetailModal from "./CheckDetailModal";
import PrimaryDataTable from "../../../../components/PrimaryDataTable";

// api
import { getCustomerSummaryOutstandingBalance } from "../../../../api/collections";

// data and consts
import { obColumns } from "./const";

const OutstandingBalance = ({ customer_code }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // detail
  const [detailModal, setDetailModal] = useState({ toggle: false, data: [] });

  useEffect(() => loadData(customer_code), [customer_code]);

  const loadData = (customerCode) => {
    if (customerCode === "") return;

    setLoading(true);
    setData([]);

    getCustomerSummaryOutstandingBalance(customerCode).then((res) => {
      setLoading(false);
      const { code, result } = res.data.response;

      if (code === "00000") {
        setData(
          result.sales_invoices.map((row, index) => ({
            ...row,
            id: customerCode + "_" + index,
          }))
        );
      }
    });
  };

  const handleShowCheckDetails = (row) =>
    setDetailModal({ toggle: true, data: row.check_details });

  let columns = obColumns({
    handleShowCheckDetails: handleShowCheckDetails,
  });

  return (
    <Fragment>
      <PrimaryDataTable
        key={customer_code}
        rows={data}
        columns={columns}
        disableColumnSelector={true}
        disableSelectionOnClick
        hasGridToolbar
        loading={loading}
      />
      <CheckDetailModal
        toggle={detailModal.toggle}
        closeModal={() => setDetailModal({ toggle: false, data: [] })}
        data={detailModal.data}
        type="customer_center_outstanding_balance"
      />
    </Fragment>
  );
};

export default OutstandingBalance;
